import type { ReactNode } from "react";
import { DashboardPanel } from "./DashboardPanel";
import { DashboardSectionHeader } from "./DashboardSectionHeader";

export function DashboardChartCard({
  title,
  subtitle,
  children,
  className,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <DashboardPanel className={className}>
      <div className="p-4">
        <DashboardSectionHeader title={title} subtitle={subtitle} />
        {children}
      </div>
    </DashboardPanel>
  );
}
